import React from "react";
import { legalContent } from "../mock";
import { ScrollText } from "lucide-react";

const Legal = ({ type }) => {
  const data = legalContent[type] || legalContent.terms;
  return (
    <div>
      <section className="relative pt-36 pb-16 bg-[#0a121a] border-b border-white/5 overflow-hidden">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[40rem] rounded-full bg-[var(--gold)]/8 blur-3xl" />
        <div className="relative max-w-3xl mx-auto px-5 text-center">
          <ScrollText className="reveal mx-auto text-[var(--gold)] mb-4" size={34} />
          <h1 className="reveal font-display text-3xl sm:text-5xl font-extrabold text-white">{data.title}</h1>
          <p className="reveal mt-5 text-muted-foreground">{data.intro}</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-5 space-y-8">
          {data.sections.map((s, i) => (
            <div key={i} className="reveal rounded-2xl border border-white/10 bg-[#13212e] p-7">
              <h2 className="font-display text-lg font-bold text-[var(--gold)]">{s.h}</h2>
              <p className="mt-3 text-muted-foreground leading-relaxed">{s.p}</p>
            </div>
          ))}
          <p className="reveal text-xs text-muted-foreground text-center pt-4">
            Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}. This is a demo page with sample content.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Legal;
